import React, { useEffect, useState } from "react";
import TopProject from "../TopProject/TopProject";

const TopProjects = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("./data-json/top.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <section id="projects" className="work" data-aos="fade-up">
      <div className="work__inner">
        <h2 className="work__title">Selected work</h2>
        <p className="work__subtitle">
          A few things I’d stand behind in a room full of skeptics.
        </p>
        {projects.map((project) => (
          <TopProject key={project.id} project={project} />
        ))}
      </div>
    </section>
  );
};

export default TopProjects;
